import { useState } from "react";
import { Play } from "lucide-react";

export default function VideoCard({ label, desc, embedUrl, videoFile, videoFileWebm, poster, testId }) {
  const [playing, setPlaying] = useState(false);

  return (
    <div
      data-testid={testId}
      className="group relative overflow-hidden rounded-2xl bg-navy-950 shadow-xl shadow-navy-900/10 ring-1 ring-navy-900/10"
    >
      <div className="relative aspect-video">
        {playing && embedUrl ? (
          <iframe
            src={embedUrl}
            title={label}
            className="absolute inset-0 h-full w-full"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
          />
        ) : playing && videoFile ? (
          <video controls autoPlay playsInline preload="metadata" poster={poster} className="absolute inset-0 h-full w-full bg-black object-contain">
            <source src={videoFile} type="video/mp4" />
            {videoFileWebm && <source src={videoFileWebm} type="video/webm" />}
          </video>
        ) : (
          <>
            {poster ? (
              <img loading="lazy" decoding="async" src={poster} alt={label} className="absolute inset-0 h-full w-full object-cover opacity-70 transition-transform duration-700 group-hover:scale-105" />
            ) : (
              <div className="absolute inset-0 bg-gradient-to-br from-navy-800 via-navy to-navy-950" />
            )}
            <div className="absolute inset-0 bg-gradient-to-t from-navy-950/90 via-navy-950/20 to-transparent" />
            <button
              data-testid={`${testId}-play-btn`}
              onClick={() => (embedUrl || videoFile) && setPlaying(true)}
              aria-label={`Play ${label}`}
              className="absolute inset-0 z-10 flex items-center justify-center pb-24"
            >
              <span className="relative flex h-16 w-16 items-center justify-center rounded-full bg-white/95 text-navy shadow-2xl transition-transform duration-300 group-hover:scale-110">
                {(embedUrl || videoFile) && (
                  <span className="absolute inset-0 rounded-full bg-teal-400/40 animate-pulse-ring" />
                )}
                <Play className="h-6 w-6 fill-navy" />
              </span>
            </button>
            <div className="pointer-events-none absolute bottom-0 left-0 right-0 z-0 p-5">
              <p className="font-heading text-lg font-semibold text-white">{label}</p>
              {desc && <p className="mt-1 text-sm text-slate-300 line-clamp-2">{desc}</p>}
              {!embedUrl && !videoFile && (
                <span className="mt-2 inline-block rounded-full bg-white/10 px-3 py-1 text-[11px] font-medium tracking-wide text-teal-200 ring-1 ring-white/15">
                  Video coming soon
                </span>
              )}
            </div>
          </>
        )}
      </div>
    </div>
  );
}
